// extracted by mini-css-extract-plugin
module.exports = {"container":"Rating_container__2f8u7","activeStars":"Rating_activeStars__4qAk_"};